

























import axios from 'axios'
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Links extends Vue {
  resources:object = []
  mounted () {
    axios.get('/json/resources.json')
      .then(response => {
        this.resources = [...response.data]
      })
  }
}
